export const features = [
  {
    id: 1,
    icon: "ri-file-list-3-line",
    title: "Approval Workflow System",
    description:
      "Track requested, pending, completed, and rejected approvals with automated routing and real-time notifications.",
    color: "bg-blue-50 text-blue-600",
    image:
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/f31dc3b44347511128356337f22f2db5.png",
    images: [
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/4d5cc6305dc8f57e9d3b9950d0f44596.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/a3d90d91d3e0b8af882593db2332205d.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/9581b14eed332f6afcd8946d750b7d4a.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/17096c14f1eb77bdd79d3f388b2fb0d8.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/2d01cd8a50b89aea574d898255f985a3.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/b5a8bb9bd033579bc6d6cd4d40e9a34b.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/f28ba229cd67b393fd4d72a75764739c.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/bda0c48a3afcb8aae1be8b0510204763.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/d3be96b28cf80e9cfe90cea523c80543.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/b5a3d1b15598c87eb1d7b6b84a6cc9be.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/f749effc65e6c7bdca898fa48542ca55.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/88fd4200f783fd3d96358c0092acaf27.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/2e2c05532ffc7b090135522b7c59112d.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/3b0fcc7a3f33cd67e314addb783c7df0.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/4bb84990871940494096010ab33a5101.png",
    ],
    detailContent: "Digitalizes every step from approval requests to final authorization, reducing business processing time by more than 50%.",
    benefits: [
      "Real-time push notifications for urgent tasks",
      "Mobile-optimized approval support for on-the-go access",
      "Comprehensive approval history and audit trail management"
    ],
  },
  {
    id: 2,
    icon: "ri-contacts-line",
    title: "Business Card Management",
    description:
      "Request, customize, and preview digital or printed business cards with QR code and digital sharing capability.",
    color: "bg-emerald-50 text-emerald-600",
    image:
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/70d6eb917ec781ea74e93d7862da5f5f.png",
    images: [
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/9626fc41562974c72c2dbac5ec8454de.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/3638dafb008ded72aa5f951955ccd584.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/31dc75b0d06d8e8ae905ae20e045c5f2.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/30b07981c4a5644d925453d7c7708d24.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/d73c8ec19e099306cd763f17d2b26ec5.png"
    ],
    detailContent: "Streamlines the entire workflow from request and draft review to final approval and ordering, ensuring systematic corporate identity management.",
    benefits: [
      "Real-time business card draft preview and editing",
      "Customized management and analytics by request category",
      "One-click data export to Excel for professional printing"
    ],
  },
  {
    id: 3,
    icon: "ri-car-line",
    title: "Company Car & Vehicle",
    description:
      "Manage vehicle assignments, maintenance schedules, fuel tracking, and usage reports across your fleet.",
    color: "bg-violet-50 text-violet-600",
    image:
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/7c9a67ee3a4c2f26c19226c5936a10b7.png",
    images: [
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/4c4b355d52245209aa56e8da7c0a735e.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/bdafd606f77aa69b2dc1f428ba5dfdf6.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/8980d98d3f56352414a9b42f59ee4ac6.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/ee4c4bb4dbdf40e06e9c96cc623adca9.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/1c883cadf8b09dcb91eb68d9863ecebe.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/acf16357bf85e5b06ab719361411d795.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/43c2d0f636b1feb427b7cbd169a76592.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/e2e9949ebd9201ca5c9b45e5bd3d4856.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/99ddaca023cf7158e279d0eeb8547eab.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/6921ec15d61ece581fed4e06cf58e533.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/89fb1721ee31f2b91a0281e421419be1.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/63b6f0edc02ba289b832f8e8fcc4b11f.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/d8e2295fd6e9d5fe25494dd53cc64b2b.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/806bd731c301cc83ca59172a7027ae31.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/826a28c815b985ef974562e3c3b9fc59.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/defb8a7da1eef86a5ca56ae171848a07.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/af236b3b93b3bbc303052e18f3b39ca0.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/6a7096dd976a1db5e2e514ff70539429.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/865397da8f87e2cbd1d1405fea647e1b.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/ba2cf21885bed6cdbcfc3dab5582da3d.png"
    ],
    detailContent: "An all-in-one management system for corporate fleets, covering master records, accident reporting, maintenance scheduling, and fuel tracking. It eliminates management blind spots and maximizes operational efficiency through real-time data synchronization.",
    benefits: [
      "Immediate digital accident reporting and history tracking",
      "Automated maintenance alerts and vendor reservation system",
      "Real-time pool car availability and automated trip log recording",
      "Fuel cost optimization by model and centralized master data management"
    ],
  },
  {
    id: 4,
    icon: "ri-computer-line",
    title: "IT Device & Asset Management",
    description:
      "Track devices, assets, and inventory from procurement to disposal with full lifecycle management.",
    color: "bg-amber-50 text-amber-600",
    image:
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/e9cb88bb695413c35b8fe7615512d63e.png",
    images: [
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/56a0809fe7ae55c3d38c1c9199e2f41b.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/432bfa2c33ee79af4db3310b013046df.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/13d8a6d73f86091767dc3f59e94ee173.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/bf70f5efe8e0bca248e165c3b3613492.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/a83fc7a90225b8b8433e9b07738d1143.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/75df9f6d338391d0a2d0f635480ac722.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/9e6d6ceb27e024db21cf3655ead4b6e9.png"
    ],
    detailContent: "Digitalizes the full lifecycle of corporate IT equipment, from initial request to issuance and final disposal. It flawlessly implements Request/List/Approval workflows to enhance accuracy and speed in complex asset management.",
    benefits: [
      "Simplified online request process for IT hardware and software",
      "Real-time location and status tracking via unique asset identification (UID)",
      "Enhanced resource allocation efficiency through integrated history management",
      "Transparent end-to-end asset lifecycle tracking from procurement to disposal"
    ],
  },
  {
    id: 5,
    icon: "ri-taxi-line",
    title: "Taxi & Logistics Requests",
    description:
      "Simplify employee transportation requests with quick booking, cost tracking, and approval flows.",
    color: "bg-rose-50 text-rose-600",
    image:
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/903f302884630ff87521a064821162c2.png",
    images: [
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/903f302884630ff87521a064821162c2.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/1f8b702d3a360e3fe83d2de2a8f315cf.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/47d9fff12a02b64ea3db38c4146efd75.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/9b63ef8811329cdf53521b123403e2f9.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/38e7a1b775d917a6e600f27de7e32192.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/98fd1105cf295f14f63d9f94474b802c.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/bbb51b59fba0d40dcee55f7203122da6.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/c0672be5fc2c03b903d2bd1259c052b4.png"
    ],
    detailContent: "Integrates all corporate 'mobility' and 'logistics'—from business taxi bookings to incoming and outgoing mail management. It boosts operational efficiency by eliminating manual receipt processing and providing real-time tracking.",
    benefits: [
      "Easy business taxi reservations with origin-to-destination tracking",
      "Real-time tracking of mail and parcels from registration to receipt",
      "Secure approval workflows to ensure transparent corporate mobility usage",
      "Automated aggregation of departmental delivery and transportation expenses"
    ],
  },
  {
    id: 6,
    icon: "ri-shield-check-line",
    title: "Security & Access Control",
    description:
      "Manage internal security processes, visitor logs, and access permissions across facilities.",
    color: "bg-sky-50 text-sky-600",
    image:
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/5684b903a18d054902c63504bdf0b5cb.png",
    images: [
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/5684b903a18d054902c63504bdf0b5cb.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/5d49f2a68ad5a48339dedce95e2f9f15.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/d308deb99e22e7083c032d9532f1dad6.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/dd71a662cb6e032df42f8c3a844f1975.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/b873b76dcf067b8a042f916cde886460.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/3e4024e8fad2ed93e974ceaf614bbfa1.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/976c3379996dd26caaa6e98516d49955.png",
      "https://static.readdy.ai/image/22e74f403809c5eb5ed859e1f3746460/1d544453e8d1dce1590437f073ba5eb7.png"
    ],
    detailContent: "Serves as the final security gateway for controlling the physical movement of corporate assets and vehicles in real-time. It meticulously manages Import/Export logs for items and In/Out records for vehicles based on approved data, eliminating security blind spots.",
    benefits: [
      "One-to-one physical verification against Import/Export approval data",
      "Automated recording of vehicle entry and exit (In/Out) times at the gate",
      "Immediate access control and rejection for unauthorized assets or vehicles",
      "Dedicated dashboard for security personnel with real-time access logs"
    ],
  },
];

export const steps = [
  {
    id: 1,
    number: "01",
    icon: "ri-send-plane-line",
    title: "Submit Requests",
    description:
      "Employees submit requests for assets, approvals, transportation, and more through a unified portal.",
  },
  {
    id: 2,
    number: "02",
    icon: "ri-git-branch-line",
    title: "Automated Approval Flow",
    description:
      "Requests are automatically routed to the right approvers based on predefined workflows.",
  },
  {
    id: 3,
    number: "03",
    icon: "ri-radar-line",
    title: "Real-Time Tracking",
    description: "Monitor every request in real time — know exactly where things stand at every step.",
  },
  {
    id: 4,
    number: "04",
    icon: "ri-bar-chart-2-line",
    title: "Data & Insights",
    description: "Access rich analytics and operational reports to make data-driven decisions.",
  },
];

export const benefits = [
  {
    id: 1,
    icon: "ri-timer-flash-line",
    title: "Increase Operational Efficiency",
    description:
      "Automate repetitive tasks and eliminate bottlenecks to get more done in less time.",
  },
  {
    id: 2,
    icon: "ri-robot-line",
    title: "Reduce Manual Processes",
    description:
      "Replace paper-based workflows with smart digital processes that save time and reduce errors.",
  },
  {
    id: 3,
    icon: "ri-eye-line",
    title: "Improve Transparency",
    description:
      "Every action is logged and visible — so teams stay aligned and accountable at all levels.",
  },
  {
    id: 4,
    icon: "ri-layout-grid-line",
    title: "Centralized Management",
    description:
      "All workplace operations in one platform. No more juggling between disconnected tools.",
  },
  {
    id: 5,
    icon: "ri-line-chart-line",
    title: "Scalable for Growth",
    description:
      "Built for enterprises of any size — scale features and users as your organization grows.",
  },
  {
    id: 6,
    icon: "ri-lock-2-line",
    title: "Enterprise-Grade Security",
    description:
      "Role-based access control, audit logs, and compliance tools to keep your data secure.",
  },
];

export const testimonials = [
  {
    id: 1,
    quote:
      "BizLab completely transformed how our HR and ops teams handle daily requests. What used to take days now takes minutes. The approval workflow alone saved us 20+ hours a week.",
    name: "Sarah Mitchell",
    title: "COO, Apex Technologies",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20woman%20corporate%20headshot%20confident%20smile%20business%20attire%20white%20background%20clean%20portrait&width=96&height=96&seq=avatar1&orientation=squarish",
    stars: 5,
  },
  {
    id: 2,
    quote:
      "The asset tracking and IT device management features are incredibly intuitive. Our IT team finally has full visibility into all company equipment without complex spreadsheets.",
    name: "James Park",
    title: "IT Director, Vertex Global",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20man%20corporate%20headshot%20confident%20business%20attire%20clean%20white%20background%20portrait%20executive&width=96&height=96&seq=avatar2&orientation=squarish",
    stars: 5,
  },
  {
    id: 3,
    quote:
      "From vehicle management to business cards, BizLab gives us one place to handle everything. Our employees love the simplicity and our managers love the oversight.",
    name: "Elena Kovacs",
    title: "Head of Operations, NordGroup",
    avatar:
      "https://readdy.ai/api/search-image?query=professional%20woman%20executive%20headshot%20corporate%20confident%20modern%20office%20clean%20portrait%20business&width=96&height=96&seq=avatar3&orientation=squarish",
    stars: 5,
  },
];

export const stats = [
  { id: 1, value: 100, suffix: "+", label: "Companies Onboarded" },
  { id: 2, value: 50000, suffix: "+", label: "Requests Processed" },
  { id: 3, value: 98, suffix: "%", label: "Client Satisfaction" },
  { id: 4, value: 40, suffix: "%", label: "Time Saved on Avg." },
];

export const companyLogos = [
  { id: 1, name: "Apex Technologies" },
  { id: 2, name: "Vertex Global" },
  { id: 3, name: "NordGroup" },
  { id: 4, name: "Stratos Corp" },
  { id: 5, name: "Luminary Inc" },
  { id: 6, name: "CloudBridge" },
];

export const navLinks = [
  { label: "Features", href: "#features" },
  { label: "Solutions", href: "#how-it-works" },
  { label: "Benefits", href: "#benefits" },
  { label: "Contact", href: "#contact" },
];
